import { apolloClient } from "config/apollo";
import { gql } from "config/graphql";
import {
  DynamicFormCriteriaFlowScope,
  IApiArgument,
  IDynamicForm,
  IFlowSession,
} from "config/types";
import { DYNAMIC_FORM } from "gql/fragments";

type DynamicFormResponse = {
  nextForm: IDynamicForm;
};

export const nextFormQuery = (
  flowSessionId: IFlowSession["id"],
  dynamicFormId?: IDynamicForm["id"]
) => {
  const query = gql`
    ${DYNAMIC_FORM}
    query NextForm($flowSessionId: ID!, $currentFormId: ID) {
      nextForm(flowSessionId: $flowSessionId, currentFormId: $currentFormId) {
        ...DynamicFormFields
      }
    }
  `;

  return apolloClient.query<DynamicFormResponse>({
    variables: {
      flowSessionId,
      currentFormId: dynamicFormId,
    },
    query,
  });
};

export interface IDynamicFormQueryInputs {
  flowSessionId: IFlowSession["id"];
  criteria?: IInputsDynamicFormCriteria;
  currentFormIdentifier?: IDynamicForm["id"];
  direction?: "next" | "previous";
}

export interface INextFormInput extends IDynamicFormQueryInputs {
  retryArguments?: IApiArgument[];
}

interface IInputsDynamicFormCriteria {
  action?: TDynamicFormCriteriaAction;
  flowScope?: DynamicFormCriteriaFlowScope;
  formScope?: string;
}

type TDynamicFormCriteriaAction =
  | "add_backup"
  | "add_primary"
  | "cancel"
  | "delete"
  | "dont_promote"
  | "edit_allocation"
  | "edit_beneficiary"
  | "individual"
  | "minor"
  | "organization"
  | "promote"
  | "save"
  | "trust"
  | string;

type DynamicFormQueryResponse = {
  dynamicForm: IDynamicForm;
};

export const dynamicFormQuery = async (inputPayload: INextFormInput) => {
  const query = gql`
    ${DYNAMIC_FORM}
    query DynamicForm(
      $criteria: InputsDynamicFormsFormsCriteriaAttributes
      $currentFormIdentifier: String
      $direction: DynamicFormsFormsDirection
      $flowSessionId: ID!
    ) {
      dynamicForm(
        criteria: $criteria
        currentFormIdentifier: $currentFormIdentifier
        direction: $direction
        flowSessionId: $flowSessionId
      ) {
        ...DynamicFormFields
      }
    }
  `;

  return apolloClient.query<DynamicFormQueryResponse>({
    query,
    variables: inputPayload,
  });
};
